<script>
import recovery from "./recovery";
export default {
  extends: recovery
};
</script>
